import { Emblem } from '../components/Emblem';
import { useViewport } from '../hooks/useViewport';
import { useShop } from './ShopState';

const FACEBOOK_GROUP_URL = 'https://www.facebook.com/groups/kult.operacja.teneryfa';

export function ClosurePage() {
  const { catalog } = useShop();
  const { isMobile } = useViewport();
  const message = catalog.status === 'ready' ? catalog.shopStatus.closure_message.trim() : '';

  return (
    <div className="closure">
      <div className="closure-column">
        <Emblem size={isMobile ? 120 : 160} style={{ margin: '0 auto' }} />
        <div className="closure-pill">
          <span className="closure-pill-dot" aria-hidden="true" />
          Sprzedaż zakończona
        </div>
        <h1 className="display closure-title">Sprzedaż jest już zakończona</h1>
        {message && <p className="closure-message">{message}</p>}
        <section className="closure-card">
          <h2 className="display closure-card-title">Zapraszamy na B4 Party</h2>
          <div className="closure-card-date">27.11.2026</div>
          <p className="closure-card-text">Szczegóły ogłosimy wkrótce na grupie Operacji Teneryfa.</p>
          <a className="closure-cta" href={FACEBOOK_GROUP_URL} target="_blank" rel="noopener noreferrer">
            Dołącz do grupy na Facebooku
          </a>
        </section>
        <div className="closure-footer">Koncert · 28.11.2026 · Teneryfa</div>
      </div>
    </div>
  );
}
